import React, { useEffect, useState } from "react";
import { FaCog } from "react-icons/fa";
import API_URL from "../config";
import axios from "axios";
import { useAdmin } from "../contexts/AdminContext";

const Settings = () => {
  const { admin } = useAdmin();
  const [admins, setAdmins] = useState([]);
  const [newAdmin, setNewAdmin] = useState({
    username: "",
    password: "",
    contact: "",
    branch: "",
  });

  const [gstDetails, setGstDetails] = useState({
    gstNumber: "",
    billingAddress: "",
    companyName: "",
    gstPercentage: "",
    branch: admin.branch,
  });

  const [isEditingGst, setIsEditingGst] = useState(false);
  const [contacts, setContacts] = useState(null);
  const [contactNumbers, setContactNumbers] = useState([""]);

  const handleContactChange = (index, value) => {
    const newContactNumbers = [...contactNumbers];
    newContactNumbers[index] = value;
    setContactNumbers(newContactNumbers);
  };

  const addContactNumber = () => {
    setContactNumbers([...contactNumbers, ""]);
  };

  const removeContactNumber = (index) => {
    const newContactNumbers = contactNumbers.filter((_, i) => i !== index);
    setContactNumbers(newContactNumbers);
  };

  const handleSubmit = async () => {
    if (contactNumbers.some((number) => !number.trim())) {
      alert("Please fill in all contact numbers.");
      return;
    }

    try {
      const response = await axios.put(`${API_URL}/contact`, {
        branch: admin.branch,
        numbers: contactNumbers,
      });

      fetchContacts();
      alert("Contact numbers updated successfully!");
    } catch (error) {
      console.error("Failed to update contact numbers");
    }
  };

  const fetchAdmins = async () => {
    try {
      const response = await axios.get(`${API_URL}/admin`);
      setAdmins(response.data);
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };
  const fetchContacts = async () => {
    try {
      const response = await axios.get(`${API_URL}/contact/${admin?.branch}`);
      setContactNumbers(response.data.data);
    } catch (error) {
      console.error("Error fetching contact data");
    }
  };

  const fetchGstDetails = async () => {
    try {
      const response = await axios.get(`${API_URL}/gst/get/${admin?.branch}`);
      if (response.data) {
        setGstDetails(response.data);
      }
    } catch (error) {
      console.error("Error fetching GST data:", error);
    }
  };

  useEffect(() => {
    fetchAdmins();
    fetchGstDetails();
    fetchContacts();
  }, []);

  const handleInputChange = (e) => {
    setNewAdmin({ ...newAdmin, [e.target.name]: e.target.value });
  };
  const handleGstInputChange = (e) => {
    setGstDetails({ ...gstDetails, [e.target.name]: e.target.value });
  };

  const addAdmin = async () => {
    if (
      !newAdmin.username ||
      !newAdmin.password ||
      !newAdmin.contact ||
      !newAdmin.branch
    ) {
      alert("Please fill all fields.");
      return;
    }

    try {
      await axios.post(`${API_URL}/admin/add`, newAdmin);
      alert("Admin added successfully!");
      setNewAdmin({ username: "", password: "", contact: "", branch: "" });
      fetchAdmins();
    } catch (error) {
      alert("Failed to add admin.");
    }
  };

  const saveGstDetails = async () => {
    try {
      if (!gstDetails._id) {
        await axios.post(`${API_URL}/gst/add`, gstDetails);
        alert("GST details added successfully!");
      } else {
        await axios.patch(`${API_URL}/gst/update/${admin?.branch}`, gstDetails);
        alert("GST details updated successfully!");
      }
      setIsEditingGst(false);
      fetchGstDetails();
    } catch (error) {
      alert("Failed to update GST details.");
    }
  };

  return (
    <div className="userManagementContainer">
      <div className="userManagementHeader">
        <div className="userHeaderLeft">
          <FaCog size={30} color="#ff0000" style={{ marginRight: 10 }} />
          <h2>Settings & Admin Control</h2>
        </div>
      </div>
      <div className="addUserProfileContainer">
        <h3>GST Configuration</h3>
        <div className="addUserProfileMain">
          <div className="addUserProfileInputMain">
            <div className="addUserProfileInput">
              <label>GST Number</label>
              <input
                type="text"
                name="gstNumber"
                value={gstDetails.gstNumber}
                onChange={handleGstInputChange}
                readOnly={!isEditingGst}
              />
            </div>
            <div className="addUserProfileInput">
              <label>Billing Address</label>
              <input
                type="text"
                name="billingAddress"
                value={gstDetails.billingAddress}
                onChange={handleGstInputChange}
                readOnly={!isEditingGst}
              />
            </div>
          </div>
        </div>
        <div className="addUserProfileMain">
          <div className="addUserProfileInputMain">
            <div className="addUserProfileInput">
              <label>Company/Business Name</label>
              <input
                type="text"
                name="companyName"
                value={gstDetails.companyName}
                onChange={handleGstInputChange}
                readOnly={!isEditingGst}
              />
            </div>
            <div className="addUserProfileInput">
              <label>GST Percentage</label>
              <input
                type="text"
                name="gstPercentage"
                value={gstDetails.gstPercentage}
                onChange={handleGstInputChange}
                readOnly={!isEditingGst}
              />
            </div>
          </div>
        </div>
        <div className="gstSettingBtnContainer">
          {isEditingGst ? (
            <button onClick={saveGstDetails}>Save</button>
          ) : (
            <button onClick={() => setIsEditingGst(true)}>Edit</button>
          )}
        </div>
      </div>

      <div className="addUserProfileContainer">
        <h3>Contact Number</h3>
        <div className="addUserProfileMain">
          <div className="addUserProfileInputMain" style={{ flexWrap: "wrap" }}>
            {contactNumbers.map((number, index) => (
              <div className="addUserProfileInput" key={index}>
                <label>Phone Number {index + 1}</label>
                <input
                  type="text"
                  value={number}
                  onChange={(e) => handleContactChange(index, e.target.value)}
                  placeholder="Enter phone number"
                />
                {contactNumbers.length > 1 && (
                  <button
                    type="button"
                    onClick={() => removeContactNumber(index)}
                    className="removeButton"
                    style={{
                      backgroundColor: "#ff0000",
                      border: "none",
                      outline: "none",
                      color: "white",
                      padding: 4,
                      cursor: "pointer",
                      borderRadius: 8,
                      marginTop: 4,
                    }}
                  >
                    Remove
                  </button>
                )}
              </div>
            ))}
          </div>
        </div>

        <div className="gstSettingBtnContainer">
          <button type="button" onClick={handleSubmit}>
            Save
          </button>
          <button
            type="button"
            onClick={addContactNumber}
            className="addButton"
          >
            Add Another Number
          </button>
        </div>
      </div>

      <div className="addUserProfileContainer">
        <h3>Add New Admin</h3>
        <div className="addUserProfileMain">
          <div className="addUserProfileInputMain">
            <div className="addUserProfileInput">
              <label>Username</label>
              <input
                type="text"
                name="username"
                value={newAdmin.username}
                onChange={handleInputChange}
              />
            </div>
            <div className="addUserProfileInput">
              <label>Password</label>
              <input
                type="password"
                name="password"
                value={newAdmin.password}
                onChange={handleInputChange}
              />
            </div>
          </div>
        </div>
        <div className="addUserProfileMain">
          <div className="addUserProfileInputMain">
            <div className="addUserProfileInput">
              <label>Phone Number</label>
              <input
                type="text"
                name="contact"
                value={newAdmin.contact}
                onChange={handleInputChange}
              />
            </div>
            <div className="addUserProfileInput">
              <label>Branch</label>
              <input
                type="text"
                name="branch"
                value={newAdmin.branch}
                onChange={handleInputChange}
              />
            </div>
          </div>
        </div>

        <div className="gstSettingBtnContainer">
          <button onClick={addAdmin}>Save</button>
        </div>
      </div>

      <div className="addUserProfileContainer">
        <h3>Super Admins</h3>
        <div className="table-container">
          <table className="custom-table">
            <thead>
              <tr>
                <th>Username</th>
                <th>Phone Number</th>
                <th>Branch</th>
              </tr>
            </thead>
            <tbody>
              {admins.length > 0 ? (
                admins.map((admin, index) => (
                  <tr key={index}>
                    <td>{admin.username}</td>
                    <td>{admin.contact}</td>
                    <td>{admin.branch}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" style={{ textAlign: "center" }}>
                    No admins found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Settings;
